import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import AuthCallback from './components/AuthCallback';
import Dashboard from './components/Dashboard';
import CollaboratorManagement from './components/CollaboratorManagement';
import BranchManagement from './components/BranchManagement';
import RepositoryCreate from './components/RepositoryCreate';
import { Toaster } from 'react-hot-toast';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [token, setToken] = useState(() => {
    const savedToken = localStorage.getItem('github_token');
    console.log('Initial token from localStorage:', savedToken);
    return savedToken;
  });

  const handleLogin = (newToken) => {
    console.log('Handling login with token:', newToken);
    if (!newToken) {
      console.error('Attempted to login with null/undefined token');
      return;
    }
    localStorage.setItem('github_token', newToken);
    setToken(newToken);
  };

  const handleLogout = () => {
    console.log('Handling logout');
    localStorage.removeItem('github_token');
    localStorage.removeItem('github_user');
    setToken(null);
  };

  console.log('Current token state:', token);

  return (
    <div className="App">
      <Toaster position="top-right" />
      <Router>
        <Routes>
          <Route
            path="/login"
            element={token ? <Navigate to="/dashboard" replace /> : <Login onLogin={handleLogin} />}
          />
          <Route
            path="/api/callback"
            element={<AuthCallback onLogin={handleLogin} />}
          />
          <Route
            path="/dashboard"
            element={token ? <Dashboard token={token} onLogout={handleLogout} /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/create-repo"
            element={token ? <RepositoryCreate accessToken={token} /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/collaborators/:repoName"
            element={token ? <CollaboratorManagement token={token} /> : <Navigate to="/login" replace />}
          />
          <Route
            path="/branches/:repoName"
            element={
              token ? (
                <BranchManagement token={token} />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/"
            element={
              window.location.hash ? (
                <AuthCallback onLogin={handleLogin} />
              ) : (
                <Navigate to={token ? "/dashboard" : "/login"} replace />
              )
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
